<template>
  <el-container style="width: 100%; height: 100%;">
    <lx-navigator nav-title="汽车维修培训"
                  :nav-active="navActive"
                  :menuItems="menuItems"></lx-navigator>

    <el-main style="padding: 0 10px; height: 100%; ">
      <el-row class="lx-right-title">
        <el-col>{{ displayType }}的介绍</el-col>
      </el-row>
      <el-row class="lx-right-sub-title">
        <el-col :span="20"><i></i>基本介绍</el-col>
        <el-col :span="4" style="text-align: right">
          <el-button type="primary"
                      size="small"
                      @click="handleEditIntro"
                      v-if="!editable">
            编辑
          </el-button>
          <template v-else>
            <div>
              <el-button size="small"
                          @click="handleCancelEdit">
                取消
              </el-button>
              <el-button type="primary"
                          size="small"
                          :loading="loading"
                          @click="handleSubmitEdit">
                确定
              </el-button>
            </div>
          </template>
        </el-col>
      </el-row>
      <el-row style="background: #fff;padding: 10px;">
        <el-col :span="24">
          <table border="1" style="width: 100%;">
            <tr>
              <th class="lx-table-header-cell first-column">
                介绍内容
              </th>
              <th class="first-column-content">
                <template v-if="!editable">
                  <span v-if="input" style="white-space:pre-wrap;line-height: 1.3;font-size: 14px;color: #606266">{{ input }}</span>
                  <span v-else style="font-size: 14px;color: #909399">
                    请添加介绍内容
                  </span>
                </template>
                <template v-else>
                  <el-input type="textarea"
                            v-model="input"
                            :autosize="{ minRows: 2, maxRows: 6}"
                            maxlength="1000"
                            show-word-limit
                            :placeholder="placeholder"
                            style="verticle-align: middle;" />
                </template>
              </th>
            </tr>
            <tr>
              <td class="lx-table-header-cell second-row-title">介绍视频</td>
              <td class="second-row-content">
                <div v-if="!editable" style="display: flex; align-items: center;padding-left: 10px">
                  <img v-if="video && video.name" src="../../assets/video.png">
                  <span v-if="!(video && video.name)" style="font-size: 14px;color: #909399">请上传介绍视频</span>
                  <span v-else @click="handleVideoPlay"
                        style="cursor: pointer;font-size: 14px;color: #606266">{{ this.video.name }}</span>
                </div>
                <div v-else style="display: flex; align-items: center;padding-left: 10px">
                <el-upload  ref="upload"
                            action="/teaching/video"
                            id="uploadVideo"
                            accept=".mp4"
                            :file-list="fileList"
                            :auto-upload="false"
                            :on-change="beforeUpload"
                            :on-remove="removeFile">
                  <el-button size="small"
                              type="primary">点击上传</el-button>
                  <div slot="tip"
                        class="el-upload__tip">只能上传MP4格式的文件，且不超过500M</div>
                  <div v-if="uploadResult.code === 500"
                        slot="tip"
                        class="el-upload__tip">请检查文件大小和格式，或联系管理员</div>
                </el-upload>
                </div>
              </td>
            </tr>
          </table>
        </el-col>
      </el-row>
      <el-row class="lx-right-sub-title">
        <el-col :span="20"><i></i>项目模型</el-col>
      </el-row>
      <el-row style="height: calc(100% - 303px);background: #fff;padding: 10px;">
        <el-col :size="24">
          <el-table :data="modelData" size="medium" border class="lx-table" row-class-name="lx-table-row" header-cell-class-name="lx-table-header-cell" cell-class-name="lx-table-cell">
            <el-table-column align="center"
                              label="模型展示">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.type === 1 ? '模型展示' : '结构分解' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name"
                              align="center"
                              label="资源名称">
            </el-table-column>
            <el-table-column align="center"
                              label="资源类别">
              模型
            </el-table-column>
            <el-table-column prop="resourceNo"
                              align="center"
                              label="动画序列号">
            </el-table-column>
            <el-table-column v-if="$can('view', 'tms-root-nav')"
                              align="center"
                              label="操作">
              <template slot-scope="scope">
                <el-button type="text"
                            @click="handleAddProjectModel(scope.$index, scope.row)">
                  {{ !scope.row.id ? '添加' : '编辑' }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-main>

    <lx-model-editor-box :visible.sync="dialogEditorVisible"
                         @edit-result="handleEditResult"
                         :apiIndentity="this.apiIdentity"
                         :trainProjectItemId="this.trainProjectItemId"
                         :row="rowData"></lx-model-editor-box>

    <!-- play video -->
    <el-dialog title
               :visible.sync="dialogPlay"
               width="60%"
               center
               id="video"
               @close="closeVideoDialog"
               :show-close="false">
      <video id="videoEle"
             controls
             :src="video.src"
             width="100%">
        I'm sorry; your browser doesn't support HTML5 video.
      </video>
    </el-dialog>

  </el-container>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import { mapState } from 'vuex'
import Navigator from '@/components/common/Navigator'
import StepBar from '@/components/common/StepBar'
import ModelEditor from '@/components/teaching/ModelEditor'

export default {
  props: ['displayType', 'nav-active'],

  data () {
    return {
      dialogEditorVisible: false,
      menuItems: [
        {
          index: '1-1',
          name: '',
          value: '',
          children: [
            { index: '1-1-1', name: '', value: '', route: { name: 'EngineHome' } },
            { index: '1-1-2', name: '', value: '', route: { name: 'EngineDisassemblyTools' } },
            { index: '1-1-3', name: '', value: '', route: { name: 'EngineProcessLine' } }
          ]
        },
        {
          index: '2-1',
          name: '',
          value: '',
          children: [
            { index: '2-1-1', name: '', value: '', route: { name: 'CylinderHome' } },
            { index: '2-1-2', name: '', value: '', route: { name: 'CylinderDisassemblyTools' } },
            { index: '2-1-3', name: '', value: '', route: { name: 'CylinderProcessLine' } }
          ]
        },
        {
          index: '3-1',
          name: '',
          value: '',
          children: [
            { index: '3-1-1', name: '', value: '', route: { name: 'CrankshaftHome' } },
            { index: '3-1-2', name: '', value: '', route: { name: 'CrankshaftDisassemblyTools' } },
            { index: '3-1-3', name: '', value: '', route: { name: 'CrankshaftProcessLine' } }
          ]
        },
        {
          index: '4-1',
          name: '',
          value: '',
          children: [
            { index: '4-1-1', name: '', value: '', route: { name: 'SynchronizeHome' } },
            { index: '4-1-2', name: '', value: '', route: { name: 'SynchronizeDisassemblyTools' } },
            { index: '4-1-3', name: '', value: '', route: { name: 'SynchronizeProcessLine' } }
          ]
        }
      ],
      introData: [],
      modelData: [
        // {
        //   id: null,
        //   contentType: '模型展示',
        //   name: ''
        // },
        // {
        //   id: null,
        //   contentType: '结构分解',
        //   name: ''
        // }
      ],
      input: '',
      editable: false,
      video: {
        name: '',
        src: ''
      },
      dialogPlay: false,
      fileUpload: null,
      hasFails: false,
      uploadResult: {},
      tempArr: [],
      apiIdentity: null,
      trainProjectItemId: null,
      rowData: {},
      loading: false,
      placeholder: '',
      fileList: []
    }
  },

  mounted () {
    this.getMenu()
  },

  watch: {
    menuItems: {
      handler: function (newVal, oldVal) {
        this.$nextTick(function () {
          if (newVal[3].children[2].value) {
            this.initData()
          }
        })
      },
      deep: true
    }
  },

  components: { 'lx-navigator': Navigator, 'lx-step-bar': StepBar, 'lx-model-editor-box': ModelEditor },

  computed: {
    ...mapState(['user'])
  },

  methods: {
    initData () {
      var temp = _.cloneDeep(this.menuItems)
      switch (this.displayType) {
        case '发动机':
          this.apiIdentity = temp[0].children[0].value
          this.trainProjectItemId = temp[0].value
          break
        case '气缸':
          this.apiIdentity = temp[1].children[0].value
          this.trainProjectItemId = temp[1].value
          break
        case '曲轴':
          this.apiIdentity = temp[2].children[0].value
          this.trainProjectItemId = temp[2].value
          break
        case '变速器同步器':
          this.apiIdentity = temp[3].children[0].value
          this.trainProjectItemId = temp[3].value
          break
      }
      if (this.apiIdentity) {
        this.getEngineInfo()
        this.getModelData()
      }
    },
    getEngineInfo () {
      this.$xhrGet(`/projects/items/${this.apiIdentity}/introduction`)
        .then(rs => {
          if (rs.code === 200) {
            this.introData = rs.data
            this.input = _.trim(rs.data.name ? rs.data.name.replace(/↵/g, '<br/>') : '')
            if (rs.data.video) {
              /** 若video不为null */
              this.video.name = rs.data.video.t1
              this.video.src = rs.data.video.t2
              this.fileList[0] = {}
              this.fileList[0].name = rs.data.video.t1
            } else {
              /** 否则置为初始值 */
              this.video = { name: '', src: '' }
            }
            if (!rs.data.name) {
              this.placeholder = '请添加介绍内容'
            }
          }
        })
    },
    /** 模型列表，添加编辑模型的ID都为一级菜单ID */
    getModelData () {
      this.$xhrGet(`/projects/${this.trainProjectItemId}/models`)
        .then(rs => {
          if (!_.isEmpty(rs.data)) {
            var typeArr = _.uniq(_.map(rs.data, 'type'))
          }
          if (_.indexOf(typeArr, 1) === -1) {
            rs.data.unshift(
              {
                id: null,
                type: 1,
                name: ''
              }
            )
          }
          if (_.indexOf(typeArr, 2) === -1) {
            rs.data.push(
              {
                id: null,
                type: 2,
                name: ''
              }
            )
          }
          this.modelData = rs.data
        })
    },
    handleAddProjectModel (index, row) {
      this.rowData = row
      this.dialogEditorVisible = true
    },
    handleEditIntro () {
      this.editable = true
    },
    handleCancelEdit () {
      this.input = _.trim(this.introData.name ? this.introData.name.replace(/↵/g, '<br/>') : '')
      this.editable = false
    },
    handleFileDelete () {
      /** 删除视频 */
      return this.$xhrDelete(`/projects/items/${this.apiIdentity}/introduction/video`)
    },
    handleFileSubmit () {
      /** formData request */
      let formData = new FormData()
      formData.append('file', this.fileUpload)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 60 * 60 * 1000
      }
      return this.$xhrFilePost(`/projects/items/${this.apiIdentity}/introduction`, formData, config)
    },
    handleInputSubmit () {
      let introParam = {
        name: this.input
      }
      return this.$xhrPut(`/projects/items/${this.apiIdentity}/introduction`, introParam)
    },
    handleInputDelete () {
      return this.$xhrDelete(`/projects/items/${this.apiIdentity}/introduction/content`)
    },
    handleSubmitEdit () {
      this.loading = true
      this.input = _.trim(this.input)
      var olderIntroContent = this.introData.name
      /** 有介绍内容，开始时有视频；但是后来删除了视频 */
      if (this.input && this.introData.video && this.fileList.length === 0) {
        // let _this = this
        // axios.all([this.handleFileDelete(), this.handleInputSubmit()])
        //   .then(axios.spread(function (res1, res2) {
        //     if (res1.code === 200 && res2.code === 200) {
        //       _this.loading = false
        //       _this.editable = false
        //       _this.$refs.upload.clearFiles()
        //       _this.uploadResult = {}
        //       _this.fileUpload = null
        //       _this.hasFails = false
        //       _this.getEngineInfo()
        //     }
        //   }))
        this.handleFileDelete()
            .then(rs => {
              if (rs.code === 200) {
                this.handleInputSubmit()
                  .then(rs => {
                    if (rs.code === 200) {
                      this.loading = false
                      this.editable = false
                      this.$refs.upload.clearFiles()
                      this.uploadResult = {}
                      this.fileUpload = null
                      this.hasFails = false
                      this.getEngineInfo()
                    }
                  })
              }
            })
      } else if (this.input && !this.introData.video && this.fileList.length === 0) {
        /** 有介绍内容，没有介绍视频，一开始也没有 */
        this.handleInputSubmit()
          .then(rs => {
            if (rs.code === 200) {
              this.loading = false
              this.editable = false
              this.$refs.upload.clearFiles()
              this.uploadResult = {}
              this.fileUpload = null
              this.hasFails = false
              this.getEngineInfo()
            }
          })
      } else if (!this.input && olderIntroContent && this.fileList.length > 0) {
        /** 介绍内容一开始有，但是删掉了，有视频 */
        if (this.fileUpload) {
          let _this = this
          axios.all([this.handleFileSubmit(), this.handleInputDelete()])
            .then(axios.spread(function (res1, res2) {
              if (res1.code === 200 && res2.code === 200) {
                _this.loading = false
                _this.editable = false
                _this.$refs.upload.clearFiles()
                _this.uploadResult = {}
                _this.fileUpload = null
                _this.hasFails = false
                _this.getEngineInfo()
              } else if (res1.code === 204) {
                _this.$message.error('文件内容为空!')
                _this.loading = false
              } else if (res1.code === 409 && res1.data === 1) {
                _this.$message.error('文件的类型不正确!')
                _this.loading = false
              } else if (res1.code === 409 && res1.data === 2) {
                _this.$message.error('上传的文件与当前文件内容相同!')
                _this.loading = false
              } else if (res1.code === 422) {
                _this.$message.error('文件大小超过限定大小!')
                _this.loading = false
              }
            }))
        } else {
          this.handleInputDelete()
            .then(rs => {
              if (rs.code === 200) {
                this.loading = false
                this.editable = false
                this.$refs.upload.clearFiles()
                this.uploadResult = {}
                this.fileUpload = null
                this.hasFails = false
                this.getEngineInfo()
              } else if (rs.code === 204) {
                this.$message.error('文件内容为空!')
                this.loading = false
              } else if (rs.code === 409 && rs.data === 1) {
                this.$message.error('文件的类型不正确!')
                this.loading = false
              } else if (rs.code === 409 && rs.data === 2) {
                this.$message.error('上传的文件与当前文件内容相同!')
                this.loading = false
              } else if (rs.code === 422) {
                this.$message.error('文件大小超过限定大小!')
                this.loading = false
              }
            })
        }
      } else if (!this.input && olderIntroContent && this.introData.video && this.fileList.length === 0) {
        /** 一开始有内容和视频，后来全删了 */
          this.handleFileDelete()
              .then(rs => {
                if (rs.code === 200) {
                  this.handleInputDelete()
                    .then(rs => {
                      if (rs.code === 200) {
                        this.loading = false
                        this.editable = false
                        this.$refs.upload.clearFiles()
                        this.uploadResult = {}
                        this.fileUpload = null
                        this.hasFails = false
                        this.getEngineInfo()
                      }
                    })
                }
              })
      } else if (!this.input && !olderIntroContent && this.fileList.length > 0) {
          if (this.fileUpload) {
            this.handleFileSubmit()
              .then(rs => {
                if (rs.code === 200) {
                  this.loading = false
                  this.editable = false
                  this.$refs.upload.clearFiles()
                  this.uploadResult = {}
                  this.fileUpload = null
                  this.hasFails = false
                  this.getEngineInfo()
                }
              })
          } else {
            /** 什么都没有做 */
            this.loading = false
            this.editable = false
            this.$refs.upload.clearFiles()
            this.uploadResult = {}
            this.fileUpload = null
            this.hasFails = false
            this.getEngineInfo()
          }
        } else if (this.input && this.fileList.length > 0) {
          /** 有介绍内容，有视频 */
          if (this.fileUpload) {
            let _this = this
            axios.all([this.handleFileSubmit(), this.handleInputSubmit()])
              .then(axios.spread(function (res1, res2) {
                if (res1.code === 200 && res2.code === 200) {
                  _this.loading = false
                  _this.editable = false
                  _this.$refs.upload.clearFiles()
                  _this.uploadResult = {}
                  _this.fileUpload = null
                  _this.hasFails = false
                  _this.getEngineInfo()
                } else if (res1.code === 204) {
                  _this.$message.error('文件内容为空!')
                  _this.loading = false
                } else if (res1.code === 409 && res1.data === 1) {
                  _this.$message.error('文件的类型不正确!')
                  _this.loading = false
                } else if (res1.code === 409 && res1.data === 2) {
                  _this.$message.error('上传的文件与当前文件内容相同!')
                  _this.loading = false
                } else if (res1.code === 422) {
                  _this.$message.error('文件大小超过限定大小!')
                  _this.loading = false
                }
              }))
          } else {
            this.handleInputSubmit()
              .then(rs => {
                if (rs.code === 200) {
                  this.loading = false
                  this.editable = false
                  this.$refs.upload.clearFiles()
                  this.uploadResult = {}
                  this.fileUpload = null
                  this.hasFails = false
                  this.getEngineInfo()
                }
              })
          }
      } else if (!this.input && !olderIntroContent && this.fileList.length === 0 && this.introData.video) {
        /** 没有介绍内容，视频删掉了 */
        this.handleFileDelete()
            .then(rs => {
              if (rs.code === 200) {
                this.loading = false
                this.editable = false
                this.$refs.upload.clearFiles()
                this.uploadResult = {}
                this.fileUpload = null
                this.hasFails = false
                this.getEngineInfo()
              }
            })
      } else if (this.input && !olderIntroContent && this.fileList.length === 0 && !this.introData.video) {
        this.handleInputSubmit()
            .then(rs => {
              if (rs.code === 200) {
                this.loading = false
                this.editable = false
                this.$refs.upload.clearFiles()
                this.uploadResult = {}
                this.fileUpload = null
                this.hasFails = false
                this.getEngineInfo()
              }
            })
      } else if (!this.input && olderIntroContent && this.fileList.length === 0 && !this.introData.video) {
        this.handleInputDelete()
            .then(rs => {
              if (rs.code === 200) {
                this.loading = false
                this.editable = false
                this.$refs.upload.clearFiles()
                this.uploadResult = {}
                this.fileUpload = null
                this.hasFails = false
                this.getEngineInfo()
              }
            })
      } else {
        /** 什么都没有做 */
        this.loading = false
        this.editable = false
        this.$refs.upload.clearFiles()
        this.uploadResult = {}
        this.fileUpload = null
        this.hasFails = false
        this.getEngineInfo()
      }
    },
    handleEditResult () {
      this.getModelData()
    },
    handleVideoPlay () {
      this.dialogPlay = true
      this.$nextTick(() => {
        let elem = document.getElementById('videoEle')
        elem.currentTime = 0
      })
    },
    closeVideoDialog () {
      this.dialogPlay = false
      this.$nextTick(() => {
        let elem = document.getElementById('videoEle')
        elem.pause()
      })
    },
    beforeUpload (file, fileList) {
      this.fileUpload = file.raw
      let isExcel = this.fileUpload.type === 'video/mp4'
      const isLt500M = this.fileUpload.size / 1024 / 1024 < 500
      if (this.fileUpload && !isExcel) {
        this.$message.error('上传文件必须是MP4格式!')
        this.$refs.upload.clearFiles()
        this.uploadResult = {}
        this.hasFails = false
        this.loading = false
      } else if (this.fileUpload && !isLt500M) {
        this.$message.error('上传文件大小不能超过 500MB!')
        this.$refs.upload.clearFiles()
        this.uploadResult = {}
        this.hasFails = false
        this.loading = false
      } else {
        this.fileList = [{}]
        this.fileList[0].name = file.name
      }
    },
    removeFile () {
      this.fileList = []
    },
    getMenu () {
      var temp = _.cloneDeep(this.menuItems)
      this.$xhrGet(`/projects`)
        .then(rs => {
          for (let i = 0, len = rs.data.length; i < len; i++) {
            temp[i].name = rs.data[i].name
            temp[i].value = rs.data[i].value
          }
          for (let j = 0, lenth = temp.length; j < lenth; j++) {
            this.$xhrGet(`/projects/${temp[j].value}`)
              .then(rs => {
                for (var k = 0, len = rs.data.length; k < len; k++) {
                  var tempArr = temp[j].children
                  tempArr[k].name = rs.data[k].name
                  tempArr[k].value = rs.data[k].value
                }
              })
          }
        })
      this.menuItems = temp
    }
  }
}
</script>

<style lang="scss" scoped>
#video /deep/ {
  .el-dialog__body {
    padding: 0px;
  }
}
#video /deep/ {
  .el-dialog__header {
    padding: 0px;
  }
}
#uploadVideo /deep/ {
  .el-upload__tip {
    margin-top: -25px;
    color: #b8b8b8;
    height: 40px;
  }
}
#uploadVideo /deep/ {
  .el-upload-list__item-status-label {
    right: 75%;
  }
}
#uploadVideo /deep/ {
  .el-icon-upload-success {
    display: none
  }
}
.el-textarea {
  vertical-align: middle;
}
.el-textarea.is-disabled /deep/ .el-textarea__inner {
  background-color: #fff;
  border-color: transparent;
  color: #606266;
  cursor: not-allowed;
}
.first-column {
  border: 1px solid #F0F0F0;
  height: 60px;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  color: #484F62
}
.first-column-content {
  border: 1px solid #F0F0F0;
  padding: 5px 10px;
  vertical-align: middle
}
.second-row-title {
  border: 1px solid #F0F0F0;
  width: 15%;
  vertical-align: middle;
  text-align: center;
  font-size: 14px;
  color: #484F62
}
.second-row-content {
  border: 1px solid #F0F0F0;
  width: 85%;
  height: 60px;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/teaching/TeachingHome.vue